// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91c79ed8","400":"b4d3c019","453":"0693dd4c","667":"74d1ebff"}[chunkId] + ".chunk.js";
};